export default __webpack_public_path__ + "static/media/Talent_Sturdy.6a44ff36.png";